var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconQuinella(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.114,
    height: 16.967
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-quinella_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#737c81",
    d: "M0 0h16.114v16.967H0z",
    "data-name": "Rectangle 1410"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Quinella"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-quinella_svg__a)",
    "data-name": "Group 3327"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffb100",
    d: "M.75 3.328A1.547 1.547 0 102.3 1.781 1.547 1.547 0 00.75 3.328",
    "data-name": "Path 5715"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aeb7bc",
    d: "M.75 13.641a1.547 1.547 0 101.55-1.547 1.547 1.547 0 00-1.55 1.547",
    "data-name": "Path 5716"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M9.693 11.061l-2.578 2.578 2.578 2.578",
    "data-name": "Path 5717"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M9.693.75L7.115 3.328l2.578 2.578",
    "data-name": "Path 5718"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M7.115 13.641h3.093a5.156 5.156 0 100-10.313H7.115",
    "data-name": "Path 5719"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi4xMTQiIGhlaWdodD0iMTYuOTY3Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgZD0iTTAgMGgxNi4xMTR2MTYuOTY3SDB6IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDEwIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJJY29uIC0gUXVpbmVsbGEiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGNsaXAtcGF0aD0idXJsKCNhKSIgZGF0YS1uYW1lPSJHcm91cCAzMzI3Ij48cGF0aCBzdHJva2U9IiNmZmIxMDAiIGQ9Ik0uNzUgMy4zMjhBMS41NDcgMS41NDcgMCAxIDAgMi4zIDEuNzgxIDEuNTQ3IDEuNTQ3IDAgMCAwIC43NSAzLjMyOCIgZGF0YS1uYW1lPSJQYXRoIDU3MTUiLz48cGF0aCBzdHJva2U9IiNhZWI3YmMiIGQ9Ik0uNzUgMTMuNjQxYTEuNTQ3IDEuNTQ3IDAgMSAwIDEuNTUtMS41NDcgMS41NDcgMS41NDcgMCAwIDAtMS41NSAxLjU0NyIgZGF0YS1uYW1lPSJQYXRoIDU3MTYiLz48cGF0aCBzdHJva2U9IiM3MzdjODEiIGQ9Im05LjY5MyAxMS4wNjEtMi41NzggMi41NzggMi41NzggMi41NzgiIGRhdGEtbmFtZT0iUGF0aCA1NzE3Ii8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNOS42OTMuNzUgNy4xMTUgMy4zMjhsMi41NzggMi41NzgiIGRhdGEtbmFtZT0iUGF0aCA1NzE4Ii8+PHBhdGggc3Ryb2tlPSIjNzM3YzgxIiBkPSJNNy4xMTUgMTMuNjQxaDMuMDkzYTUuMTU2IDUuMTU2IDAgMSAwIDAtMTAuMzEzSDcuMTE1IiBkYXRhLW5hbWU9IlBhdGggNTcxOSIvPjwvZz48L2c+PC9zdmc+Cg==";
export { SvgIconQuinella as ReactComponent };